import { useEffect, useState } from "react";

/* Site-wide header scroll state, ported from the v0 prototype's HomeHeader.

   The bar is frosted glass while the page sits at the top and fades to solid
   black once the reader is about halfway down the first screen (the hero
   photo). It never hides: the old scroll-direction show/hide is gone, so the
   header is always reachable. rAF-throttled so the handler runs at most once
   per frame. The threshold is a fraction of the viewport height because every
   page's hero is sized against the viewport. */
const THRESHOLD = 0.5;

export default function useHeaderScroll() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      setScrolled(window.scrollY > window.innerHeight * THRESHOLD);
    };
    const onScroll = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return scrolled;
}
